<template>
	<div class="sy-ch-main container-fluid container500">
		<div class="auto ho-co-slider mt2" v-for = "(ID, index) in indices" :style = "checkInclude(preOrderSetting['Fulfilment Modes'], items[ID]['Show To'])">
			<div class="flexslider">
				<ul class="slides">
					<li v-for = "slide in items[ID].Slides">
						<a :href="slide.Link" v-if = "slide.Link" target="_blank">
							<img class="img100" :src = 'slide.Photo' >
						</a>
						<img class="img100" :src = 'slide.Photo' v-else>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
var dbPath, docID;
export default{
	data(){
		return{
			oriItem: this.$parent.$parent.merchantAds,
			items: {},
			indices: [],

			preOrderSetting: {}
		}
	},
	mounted(){
		setTimeout(()=>{
			$('.ho-co-slider .flexslider').flexslider({
				animation: 'fade',
				autoplay: true,
				directionNav: false,
				controlNav: true,
				touch: true,
				slideshowSpeed: 3000,
				after: function(slider) {
					if(!(slider.playing)) {
						$(slider).flexslider('play');
					} 
				}
			});
			var cat_width = 0;
			$('.product-category.home ul li').each(function(index,value){
				cat_width += $(this).width()+37;
			});
			$('.horizontal-scroll ul').width(cat_width);
		},1000);
	},
	firestore(){
		dbPath = "settings";
		docID = "merchantAds";
		this.$binding("preOrderSetting", myFB.db.collection("business/" + this.$route.params.businessID + "/settings").doc("preOrderSetting")).then(r=>{
			this.items = myCopier.copy(this.oriItem["Banner"]) || {}
			this.indices = myCopier.copy(this.oriItem["BannerIndices"]) || []
			setTimeout(()=>{
				customJS.runAll();
			}, 300);
		});
	},
	watch:{
		"$parent.$parent.merchantAds"(){
			this.oriItem = this.$parent.$parent.merchantAds;
			this.items = myCopier.copy(this.oriItem["Banner"]) || {};
			this.indices = myCopier.copy(this.oriItem["BannerIndices"]) || [];
		}
	},
	methods:{
		checkInclude(fModes, showTo){
			var show =  showTo.some(r=>{
				return fModes.includes(r);
			})
			if (show){
				return {
					display: "block"
				}
			}
			return{
				display: "none"
			}
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/WhatIsNew.vue